import { render } from "./ProfileSettings.vue?vue&type=template&id=070d1e4e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ProfileSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "070d1e4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('070d1e4e', __exports__)) {
    api.reload('070d1e4e', __exports__)
  }
  
  module.hot.accept("./ProfileSettings.vue?vue&type=template&id=070d1e4e", () => {
    api.rerender('070d1e4e', render)
  })

}


export default __exports__